import { IconGrouping } from '~/design-system';
import type { ModuleDefinition } from '~/platform/registry/types';

/* ------------------------------------------------------------------ *
 * The grouping board — the old admin's "Aggrupación", rebuilt on the
 * demand model: every confirmed line of the day, collapsed per
 * product, with the supplier who covers it stamped on the row. This
 * is where "who brings what tomorrow morning" gets decided.
 * ------------------------------------------------------------------ */

export const groupingModule: ModuleDefinition = {
  id: 'grouping',
  i18nNamespace: 'grouping',
  requires: { subject: 'purchase', action: 'read' },

  nav: {
    labelKey: 'grouping:nav',
    icon: IconGrouping,
    to: 'grouping',
    group: 'trade',
    order: 15,
  },

  routes: [{ path: 'grouping', component: () => import('./GroupingPage') }],

  commands: [
    {
      id: 'grouping.open',
      labelKey: 'grouping:title',
      groupKey: 'grouping:title',
      run: ({ businessSlug, navigate }) => navigate(`/b/${businessSlug}/grouping`),
    },
  ],
};
